import { render } from "./ProductBody.vue?vue&type=template&id=26cb60cf&scoped=true"
import script from "./ProductBody.vue?vue&type=script&lang=js"
export * from "./ProductBody.vue?vue&type=script&lang=js"

import "./ProductBody.vue?vue&type=style&index=0&id=26cb60cf&lang=scss"
import "./ProductBody.vue?vue&type=style&index=1&id=26cb60cf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cb60cf"],['__file',"webpack-assets/vue/templates/product/catalog/parts/ProductBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26cb60cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26cb60cf', __exports__)) {
    api.reload('26cb60cf', __exports__)
  }
  
  module.hot.accept("./ProductBody.vue?vue&type=template&id=26cb60cf&scoped=true", () => {
    api.rerender('26cb60cf', render)
  })

}


export default __exports__